import parseTypography from '@converdy/styles/parsers/parse-typography'
import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'


export default function headerStyles({
  height,
  background,
  color,
  typography,
}) {
  
  let jss = {
    '& .topbar':  {
      background,
      color,
      ...merge( 
        parseTypography(typography),
        parseResponsiveProperty(v => {
          return v && v.value && v.unit ? {
            'min-height': v.value + v.unit,
          } : {} 
        }, height)
      )
    }
  }


  return jss
}
